module.exports = __webpack_public_path__ + "img/co.d4cd6dbd.svg";